import { render } from "./Index.vue?vue&type=template&id=9281e95a&bindings={\"tenants\":\"props\",\"search_query\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "9281e95a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9281e95a')) {
    api.reload('9281e95a', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=9281e95a&bindings={\"tenants\":\"props\",\"search_query\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}", () => {
    api.rerender('9281e95a', render)
  })

}

script.__file = "resources/js/Pages/Tenants/Index.vue"

export default script